/*
jltx	西楚霸王
l8	三少爷的剑
l6	倩女幽魂录
dfzj	爆裂天空
l8hmt	三少爷的剑(港澳台)
lv02	功夫熊猫
l4	一起消消毒
lv01	绝地战警
l7	绝代双骄手游
l7tw	绝代双骄(台湾)
tkzj	太空战机
l16	猪场怼怼乐
cwwg	宠物王国
msry	火拼萌萌消
l34	妖与秋梁
lh01	潮人篮球
pm01	飞刀又见飞刀
mn05	Flower Bay
l10as	倩女手游(东南亚)
l10th	倩女手游(泰国)
 */

export const FILTER_PROJECT_CODES = [
  'jltx',
  'l8',
  'l6',
  'dfzj',
  'l8hmt',
  'lv02',
  'l4',
  'lv01',
  'l7',
  'l7tw',
  'tkzj',
  'l16',
  'cwwg',
  'msry',
  'l34',
  'lh01',
  'pm01',
  'mn05',
  'l10as',
  'l10th'
];

